import ErrorGeneric from '../../components/ErrorGeneric';
import packageJson from '../../../package.json';
import Stopper from '../../components/Stopper';
import { ordersRoutes } from '../../pages/profile/orders/routes';
import { configureLineRoutes } from '../../pages/ConfigureLine/routes';
import { billsRoutes } from '../../pages/bills/routes';
import { exploreRoutes } from '../../pages/explore/routes';
import { problemsRoutes } from '../../pages/support/routes';
import { escalationRoutes } from '../../pages/Escalation/routes';
import { profileRoutes } from '../../pages/profile/routes';
import { homeRoutes } from '../../pages/home/routes';
import { loginRoutes } from '../../pages/Login/routes';
import { logoutRoutes } from '../../pages/Logout/routes';
import { ssoRoutes } from '../../pages/SSO/routes';

export interface IRoute {
    path: string;
    element: JSX.Element;
}

export const baseRoutes: IRoute[] = [
    { path: '/stopper', element: <Stopper /> },
    { path: '/error', element: <ErrorGeneric /> },
    {
        path: '/version',
        element: (
            <>
                <div
                    style={{
                        fontSize: '50px',
                        margin: '0 auto',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    VERSION: {packageJson.version}
                </div>
            </>
        ),
    },
];

baseRoutes.push(...loginRoutes);
baseRoutes.push(...logoutRoutes);
baseRoutes.push(...ssoRoutes);
baseRoutes.push(...homeRoutes);
baseRoutes.push(...configureLineRoutes);
baseRoutes.push(...billsRoutes);
baseRoutes.push(...profileRoutes);
baseRoutes.push(...ordersRoutes);
baseRoutes.push(...exploreRoutes);
baseRoutes.push(...problemsRoutes);
baseRoutes.push(...escalationRoutes);

export const routes = baseRoutes;
